import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import {
    SIGNIN_USER,
    SIGNOUT_USER,
    // SIGNUP_USER,
    SIGNIN_USER_SUCCESS,
    SIGNIN_USER_FAILED,
    SIGNOUT_USER_SUCCESS,
    FIRST_LOGIN,
    FIRST_LOGIN_SUCCESS,
    FIRST_LOGIN_FAILED,
    FORGOT_PASSWORD,
    BACK_TO_LOGIN,
    CHANGE_PASSWORD,CHANGE_PASSWORD_FAILED, CHANGE_PASSWORD_SUCCESS, FORGOT_PASSWORD_SUCCESS, FORGOT_PASSWORD_FAILED
} from "constants/ActionTypes";
import {validatePasswordPolicy, PASSWORD_POLICY_MESSAGE} from '../../util/util';
import {signInUserWithEmailPasswordRequest,
        changePasswordApi,
        forgotPasswordApi,
        firstLoginCheck,
        logoutUserApi,
} from "../../appRedux/api/Auth";
import { apiHandler, AUTH_PASSWORD_FORGOT_SUCCESS, IDP_INQUIRY_SUCCESS } from "./handler";
import { legacyFirstLoginPayload } from "../../appRedux/api/idpHelpers";
// import {userSignInSuccess, userSignOutSuccess, userSignUpSuccess} from "../../appRedux/actions/Auth";
// import {showMessage, hideLoader} from "../../appRedux/actions/Common";


// function here

// function* createUserWithEmailPassword({payload}) {
//     const {email, password} = payload;
//     try {
//         const signUpUser = yield call(createUserWithEmailPasswordRequest, email, password);
//         if (signUpUser.message) {
//             yield put(showMessage(signUpUser.message));
//         } else {
//             localStorage.setItem('user_id', signUpUser.user.uid);
//             yield put({type: 'SIGNIN_USER_SUCCESS', payload: signUpUser.user.uid});
//         }
//     } catch (error) {
//         yield put(showMessage(error));
//     }
// }

function* signIn({payload}) {
    try {
        const signInUser = yield call(signInUserWithEmailPasswordRequest, payload);
        if (signInUser.data.abstractResponse.responseStatus === 'AUTH000') {

            let auth = {
                authToken : signInUser.data.authToken,
                deviceId : signInUser.data.authDevice,
                userId : signInUser.data.memberId,
                merchantId : signInUser.data.merchantId,
                firstName : signInUser.data.firstName,
                merchantName : signInUser.data.merchantName,
                userPic : signInUser.data.userPic
            }

            localStorage.removeItem('menuMerchant');
            localStorage.removeItem('userData');

            localStorage.setItem('u', signInUser.data.memberId);
            localStorage.setItem('f', signInUser.data.firstName);
            localStorage.setItem('mt', signInUser.data.merchantId);
            localStorage.setItem('a', signInUser.data.authToken);
            localStorage.setItem('d', signInUser.data.authDevice);
            localStorage.setItem('mtn',signInUser.data.merchantName);
            localStorage.setItem('upic',signInUser.data.userPic);


            yield put({type: SIGNIN_USER_SUCCESS, payload: auth});
            yield put({type: FIRST_LOGIN, payload: auth})
        } else {
            yield put({type: SIGNIN_USER_FAILED, payload: signInUser.data.abstractResponse.responseMessage});
        }
    } catch (error) {
        if(error.response.status === 500) {
            yield put({type: SIGNIN_USER_FAILED, payload: error.response.data.abstractResponse.responseMessage +` Please Contact the Administrator`});
        }else if(error.response !== undefined) {
            yield put({type: SIGNIN_USER_FAILED, payload: error.response.data ? error.response.data.abstractResponse.responseMessage : error.response.data ? error.response.data.responseMessage : 'An error occurred'});
        }else{
            yield put({
                type: SIGNIN_USER_FAILED,
                payload: 'Please Check Your Internet Conection'
            });
        }
    }
}

function* postForgotPassword({ payload }) {
    const { ok, data, message } = yield* apiHandler(forgotPasswordApi, payload, {
        successCodes: AUTH_PASSWORD_FORGOT_SUCCESS,
        suppressAuthRedirect: true,
    });

    if (ok) {
        yield put({ type: FORGOT_PASSWORD_SUCCESS, payload: data && data.body });
    } else {
        yield put({ type: FORGOT_PASSWORD_FAILED, payload: message });
    }
}

function* postChangePassword({payload}) {
    if (!validatePasswordPolicy(payload.password)) {
        yield put({type: CHANGE_PASSWORD_FAILED, payload: PASSWORD_POLICY_MESSAGE});
        return;
    }
    const { ok, data, message } = yield* apiHandler(changePasswordApi, payload, {
        successCodes: ['MEM902'],
    });

    if (ok) {
        yield put({type: CHANGE_PASSWORD_SUCCESS, payload: data});
    } else {
        yield put({type: CHANGE_PASSWORD_FAILED, payload: message});
    }
}

function* getFirstLogin({ payload }) {
    const { userId, authToken } = payload || {};
    if (userId && authToken && payload != null) {
        const { ok, data, message } = yield* apiHandler(firstLoginCheck, payload, {
            successCodes: ['MER019', ...IDP_INQUIRY_SUCCESS],
        });

        if (ok) {
            yield put({
                type: FIRST_LOGIN_SUCCESS,
                payload: legacyFirstLoginPayload(data),
            });
        } else {
            yield put({ type: FIRST_LOGIN_FAILED, payload: message });
        }
    }
}

function* signOut() {
    try {
        yield call(logoutUserApi);
    } catch (error) {
        // Tetap lanjutkan logout meski API gagal
    } finally {
        localStorage.removeItem('u');
        localStorage.removeItem('f');
        localStorage.removeItem('mt');
        localStorage.removeItem('a');
        localStorage.removeItem('d');
        localStorage.removeItem('mtn');
        localStorage.removeItem('upic');
        localStorage.removeItem('menuMerchant');
        localStorage.removeItem('userData');
        localStorage.removeItem('firstL');
        localStorage.removeItem('listUser');
        localStorage.removeItem('userId');
        yield put({type: SIGNOUT_USER_SUCCESS});
    }
}

export function* signInUser() {
    yield takeEvery(SIGNIN_USER, signIn);
}

export function* changePassword() {
    yield takeEvery(CHANGE_PASSWORD, postChangePassword);
}

export function* forgotPassword() {
    yield takeEvery(FORGOT_PASSWORD, postForgotPassword);
}

export function* firstLogin() {
    yield takeEvery(FIRST_LOGIN, getFirstLogin);
}
export function* signOutUser() {
    yield takeEvery(SIGNOUT_USER, signOut);
}

// yield all

// export default function* rootSaga() {
//     yield all([fork(signInUser),
//         fork(createUserAccount),
//         fork(signOutUser)]);
// }

export default function* rootSaga() {
    yield all([
        fork(signInUser),
        fork(changePassword),
        fork(forgotPassword),
        fork(firstLogin),
        fork(signOutUser),
    ]);
}
